export default "__VITE_ASSET__oLEqrYvc__"